module.exports = __webpack_public_path__ + "img/default-user.ee262c61.png";